(function () {
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function initBulkGuided(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var configEl = root.querySelector('[data-guided-config]');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var minQty = Number(config.minQty) || 11;
    var minAmountCents = Number(config.minAmountCents) || 1000000;
    var discountPct = Number(config.discountPercent) || 20;
    var discountCode = config.discountCode || 'BULK20';
    var applyMethod = config.discountApplyMethod || 'automatic';
    var useCases = config.useCases || [];
    var catalog = config.catalog || [];

    var lines = {};
    var currentStep = 1;
    var activeUseCase = null;
    var dockExpanded = false;
    var isMobile = window.matchMedia('(max-width: 989px)').matches;
    var lastUseCaseTap = 0;

    var els = {
      lanes: root.querySelectorAll('[data-guided-lane]'),
      lanePanels: root.querySelectorAll('[data-guided-lane-panel]'),
      stepPanels: root.querySelectorAll('[data-guided-step]'),
      stepDots: root.querySelectorAll('[data-guided-step-dot]'),
      useCaseGrid: root.querySelector('[data-guided-use-cases]'),
      manifest: root.querySelector('[data-guided-manifest]'),
      catalogPanel: root.querySelector('[data-guided-catalog]'),
      catalogSearch: root.querySelector('[data-guided-catalog-search]'),
      catalogList: root.querySelector('[data-guided-catalog-list]'),
      meterQty: root.querySelector('[data-guided-meter-qty]'),
      meterQtyBar: root.querySelector('[data-guided-meter-qty-bar]'),
      meterAmt: root.querySelector('[data-guided-meter-amt]'),
      meterAmtBar: root.querySelector('[data-guided-meter-amt-bar]'),
      meterStatus: root.querySelector('[data-guided-meter-status]'),
      totalQty: root.querySelector('[data-guided-total-qty]'),
      subtotal: root.querySelector('[data-guided-subtotal]'),
      savings: root.querySelector('[data-guided-savings]'),
      total: root.querySelector('[data-guided-total]'),
      cta: root.querySelector('[data-guided-cta]'),
      message: root.querySelector('[data-guided-message]'),
      backBtn: root.querySelector('[data-guided-back]'),
      useCaseLabel: root.querySelector('[data-guided-use-case-label]'),
      toggleCatalog: root.querySelector('[data-guided-toggle-catalog]'),
      sidebar: root.querySelector('[data-guided-sidebar]'),
      dockBackdrop: root.querySelector('[data-guided-dock-backdrop]'),
      dockSummary: root.querySelector('[data-guided-dock-summary]'),
      dockQty: root.querySelector('[data-guided-dock-qty]'),
      mobileStart: root.querySelector('[data-guided-mobile-start]'),
    };

    function updateStepClass() {
      root.classList.toggle('is-guided-step-1', currentStep === 1);
      root.classList.toggle('is-guided-step-2', currentStep === 2);
    }

    function setDockExpanded(expanded) {
      dockExpanded = expanded;
      if (!els.sidebar) return;
      els.sidebar.classList.toggle('is-mobile-collapsed', !expanded);
      var toggle = root.querySelector('[data-guided-dock-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (els.dockBackdrop) {
        els.dockBackdrop.hidden = !expanded;
        els.dockBackdrop.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      }
      document.body.classList.toggle('bulk-guided-scroll-lock', expanded && isMobile);
    }

    function triggerUseCase(useCaseId) {
      var now = Date.now();
      if (now - lastUseCaseTap < 350) return;
      lastUseCaseTap = now;
      loadStarterPack(useCaseId);
    }

    function bindUseCaseButtons() {
      if (!els.useCaseGrid) return;
      els.useCaseGrid.querySelectorAll('[data-guided-use-case]').forEach(function (btn) {
        if (btn.dataset.bound === 'true') return;
        btn.dataset.bound = 'true';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          triggerUseCase(btn.getAttribute('data-guided-use-case'));
        });
        btn.addEventListener('touchend', function (e) {
          e.preventDefault();
          triggerUseCase(btn.getAttribute('data-guided-use-case'));
        }, { passive: false });
      });
    }

    function renderUseCases() {
      if (!els.useCaseGrid) return;
      if (els.useCaseGrid.querySelector('[data-guided-use-case]')) {
        bindUseCaseButtons();
        return;
      }
      els.useCaseGrid.innerHTML = useCases.map(function (uc) {
        return (
          '<button type="button" class="bulk-guided__use-case" data-guided-use-case="' + uc.id + '">' +
            '<span class="bulk-guided__use-case-icon" aria-hidden="true">' + (uc.icon || '📦') + '</span>' +
            '<span class="bulk-guided__use-case-label">' + uc.label + '</span>' +
            '<span class="bulk-guided__use-case-desc">' + uc.description + '</span>' +
            '<span class="bulk-guided__use-case-cta">Build starter list →</span>' +
          '</button>'
        );
      }).join('');
      bindUseCaseButtons();
    }

    function updateDockSummary(t) {
      if (!isMobile) return;
      if (els.dockQty) els.dockQty.textContent = t.totalQty + ' unit' + (t.totalQty === 1 ? '' : 's');
      if (els.dockSummary) {
        if (currentStep === 1 && t.totalQty === 0) {
          els.dockSummary.textContent = 'Pick a use case above to start';
        } else if (t.eligible) {
          els.dockSummary.textContent = formatMoney(t.total) + ' · ' + discountPct + '% off unlocked';
        } else if (t.totalQty > 0) {
          els.dockSummary.textContent = formatMoney(t.total) + ' · add more to unlock ' + discountPct + '%';
        } else {
          els.dockSummary.textContent = 'Add products to your list';
        }
      }
    }

    function lineKey(variantId) {
      return String(variantId);
    }

    function getVariantFromProduct(product, variantId) {
      var variants = product.variants || [];
      if (variantId) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) return variants[i];
        }
      }
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available) return variants[j];
      }
      return variants[0] || null;
    }

    function findCatalogProduct(productId) {
      for (var i = 0; i < catalog.length; i++) {
        if (String(catalog[i].id) === String(productId)) return catalog[i];
      }
      return null;
    }

    function setLine(variantId, data) {
      var key = lineKey(variantId);
      if (!data || !data.qty) {
        delete lines[key];
      } else {
        lines[key] = data;
      }
      renderManifest();
      updateTotals();
    }

    function addOrUpdateLine(product, variant, qty) {
      if (!variant || !variant.available) return;
      var key = lineKey(variant.id);
      var existing = lines[key];
      var newQty = (existing ? existing.qty : 0) + (qty || 1);
      lines[key] = {
        variantId: variant.id,
        productId: product.id,
        title: product.title,
        variantTitle: variant.title !== 'Default Title' ? variant.title : '',
        sku: variant.sku || '',
        price: variant.price,
        qty: newQty,
        image: product.image || '',
        variants: product.variants,
      };
      renderManifest();
      updateTotals();
    }

    function loadStarterPack(useCaseId) {
      var uc = null;
      for (var i = 0; i < useCases.length; i++) {
        if (useCases[i].id === useCaseId) { uc = useCases[i]; break; }
      }
      if (!uc) return;
      activeUseCase = uc;
      lines = {};
      (uc.starters || []).forEach(function (item) {
        if (!item.variantId || !item.qty) return;
        lines[lineKey(item.variantId)] = {
          variantId: item.variantId,
          productId: item.productId,
          title: item.title,
          variantTitle: item.variantTitle || '',
          sku: item.sku || '',
          price: item.price,
          qty: item.qty,
          image: item.image || '',
          variants: item.variants || [],
        };
      });
      if (els.useCaseLabel) els.useCaseLabel.textContent = uc.label;
      renderManifest();
      goToStep(2);
      if (isMobile) {
        var mainEl = root.querySelector('.bulk-guided__main');
        if (mainEl) mainEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function goToStep(step) {
      currentStep = step;
      els.stepPanels.forEach(function (panel) {
        var n = Number(panel.getAttribute('data-guided-step'));
        panel.hidden = n !== step;
      });
      els.stepDots.forEach(function (dot) {
        var n = Number(dot.getAttribute('data-guided-step-dot'));
        dot.classList.toggle('is-active', n === step);
        dot.classList.toggle('is-done', n < step);
      });
      if (step === 1) {
        activeUseCase = null;
        lines = {};
        renderManifest();
        setDockExpanded(false);
      } else if (step === 2 && isMobile) {
        setDockExpanded(false);
      }
      if (els.mobileStart) els.mobileStart.hidden = step !== 1;
      updateStepClass();
      updateTotals();
    }

    function calcTotals() {
      var totalQty = 0;
      var subtotal = 0;
      Object.keys(lines).forEach(function (k) {
        totalQty += lines[k].qty;
        subtotal += lines[k].price * lines[k].qty;
      });
      // Bulk 20% unlocks only on order value (>= ₹10,000), not unit count.
      var eligible = subtotal >= minAmountCents;
      var savings = eligible ? Math.round(subtotal * discountPct / 100) : 0;
      return { totalQty: totalQty, subtotal: subtotal, savings: savings, total: subtotal - savings, eligible: eligible };
    }

    function updateTotals() {
      var t = calcTotals();
      var amtPct = Math.min(100, Math.round((t.subtotal / minAmountCents) * 100));

      if (els.meterQtyBar) els.meterQtyBar.style.width = '0%';
      if (els.meterAmtBar) els.meterAmtBar.style.width = amtPct + '%';
      if (els.meterQty) els.meterQty.textContent = t.totalQty + ' units in list';
      if (els.meterAmt) els.meterAmt.textContent = formatMoney(t.subtotal) + ' / ' + formatMoney(minAmountCents);

      if (els.meterStatus) {
        els.meterStatus.classList.toggle('is-eligible', t.eligible && t.totalQty > 0);
        if (t.totalQty === 0) {
          els.meterStatus.textContent = 'Add items to unlock ' + discountPct + '% bulk savings';
        } else if (t.eligible) {
          els.meterStatus.textContent = discountPct + '% bulk discount unlocked';
        } else {
          var needAmt = Math.max(0, minAmountCents - t.subtotal);
          els.meterStatus.textContent =
            'Almost there — add ' + formatMoney(needAmt) + ' more to unlock ' + discountPct + '% off';
        }
      }

      if (els.totalQty) els.totalQty.textContent = String(t.totalQty);
      if (els.subtotal) els.subtotal.textContent = formatMoney(t.subtotal);
      if (els.savings) els.savings.textContent = t.savings > 0 ? '-' + formatMoney(t.savings) : formatMoney(0);
      if (els.total) els.total.textContent = formatMoney(t.total);

      if (els.cta) {
        els.cta.disabled = t.totalQty === 0;
        els.cta.textContent = t.eligible
          ? 'Add bulk order · ' + discountPct + '% off'
          : t.totalQty > 0
            ? 'Add to cart (no discount yet)'
            : 'Add items to continue';
      }

      updateDockSummary(t);
    }

    function renderManifestRow(line, key) {
      var variantOpts = (line.variants || []).map(function (v) {
        return (
          '<option value="' + v.id + '" data-price="' + v.price + '" data-sku="' + (v.sku || '') + '" data-available="' + (v.available ? 'true' : 'false') + '"' +
          (String(v.id) === String(line.variantId) ? ' selected' : '') +
          (v.available ? '' : ' disabled') + '>' +
          v.title + ' — ' + formatMoney(v.price) + '</option>'
        );
      }).join('');

      var title = line.title + (line.variantTitle && line.variantTitle !== 'Default Title' ? ' · ' + line.variantTitle : '');

      return (
        '<div class="bulk-guided__row" data-guided-row data-line-key="' + key + '">' +
          '<img class="bulk-guided__row-img" src="' + line.image + '" alt="" width="52" height="52" loading="lazy">' +
          '<div class="bulk-guided__row-main">' +
            '<p class="bulk-guided__row-title">' + title + '</p>' +
            (line.variants && line.variants.length > 1
              ? '<select class="bulk-guided__row-variant" data-guided-row-variant aria-label="Variant">' + variantOpts + '</select>'
              : '') +
            '<div class="bulk-guided__row-qty">' +
              '<button type="button" class="bulk-guided__qty-btn" data-guided-qty-minus aria-label="Decrease">−</button>' +
              '<input type="number" class="bulk-guided__qty-input" data-guided-qty value="' + line.qty + '" min="0" inputmode="numeric">' +
              '<button type="button" class="bulk-guided__qty-btn" data-guided-qty-plus aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="bulk-guided__row-end">' +
            '<span class="bulk-guided__row-total">' + formatMoney(line.price * line.qty) + '</span>' +
            '<button type="button" class="bulk-guided__row-remove" data-guided-remove aria-label="Remove">&times;</button>' +
          '</div>' +
        '</div>'
      );
    }

    function renderManifest() {
      if (!els.manifest) return;
      var keys = Object.keys(lines);
      if (!keys.length) {
        els.manifest.innerHTML = '<p class="bulk-guided__empty">Your list is empty. Pick a use case above or add products from the catalog.</p>';
        return;
      }
      els.manifest.innerHTML = keys.map(function (k) { return renderManifestRow(lines[k], k); }).join('');
    }

    function renderCatalog(filter) {
      if (!els.catalogList) return;
      var q = (filter || '').toLowerCase().trim();
      var html = '';
      catalog.forEach(function (product) {
        if (q && product.title.toLowerCase().indexOf(q) === -1 && (product.sku || '').toLowerCase().indexOf(q) === -1) return;
        var variant = getVariantFromProduct(product);
        if (!variant || !variant.available) return;
        html +=
          '<button type="button" class="bulk-guided__catalog-item" data-guided-add-product="' + product.id + '">' +
            '<img src="' + (product.image || '') + '" alt="" width="40" height="40" loading="lazy">' +
            '<span class="bulk-guided__catalog-item-title">' + product.title + '</span>' +
            '<span class="bulk-guided__catalog-item-price">' + formatMoney(variant.price) + '</span>' +
            '<span class="bulk-guided__catalog-item-add">+ Add</span>' +
          '</button>';
      });
      els.catalogList.innerHTML = html || '<p class="bulk-guided__empty">No products match your search.</p>';
    }

    function switchLane(lane) {
      els.lanes.forEach(function (btn) {
        var isActive = btn.getAttribute('data-guided-lane') === lane;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      els.lanePanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-guided-lane-panel') === lane;
        panel.classList.toggle('is-active-lane', isActive);
        panel.hidden = !isActive;
      });
      root.classList.toggle('is-lane-self', lane === 'self');
      root.classList.toggle('is-lane-concierge', lane === 'concierge');
      if (lane === 'concierge') {
        setDockExpanded(false);
        if (isMobile) document.body.classList.remove('bulk-guided-scroll-lock');
      }
    }

    switchLane('self');

    openConciergeLaneIfSuccess(root);

    renderUseCases();
    renderCatalog('');
    renderManifest();
    updateStepClass();
    updateTotals();
    setDockExpanded(false);

    window.matchMedia('(max-width: 989px)').addEventListener('change', function (e) {
      isMobile = e.matches;
      if (!isMobile) setDockExpanded(false);
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-guided-dock-toggle]')) {
        e.preventDefault();
        setDockExpanded(!dockExpanded);
        return;
      }
      if (e.target.closest('[data-guided-dock-backdrop]')) {
        e.preventDefault();
        setDockExpanded(false);
        return;
      }

      var laneBtn = e.target.closest('[data-guided-lane]');
      if (laneBtn) {
        switchLane(laneBtn.getAttribute('data-guided-lane'));
        return;
      }

      var ucBtn = e.target.closest('[data-guided-use-case]');
      if (ucBtn) {
        e.preventDefault();
        triggerUseCase(ucBtn.getAttribute('data-guided-use-case'));
        return;
      }

      if (e.target.closest('[data-guided-back]')) {
        goToStep(1);
        return;
      }

      if (e.target.closest('[data-guided-toggle-catalog]')) {
        if (els.catalogPanel) {
          var open = !els.catalogPanel.hidden;
          els.catalogPanel.hidden = open;
          e.target.closest('[data-guided-toggle-catalog]').setAttribute('aria-expanded', open ? 'false' : 'true');
          if (!open && els.catalogSearch) els.catalogSearch.focus();
        }
        return;
      }

      var addBtn = e.target.closest('[data-guided-add-product]');
      if (addBtn) {
        var product = findCatalogProduct(addBtn.getAttribute('data-guided-add-product'));
        if (product) {
          addOrUpdateLine(product, getVariantFromProduct(product), 1);
          if (currentStep === 1) goToStep(2);
        }
        return;
      }

      var row = e.target.closest('[data-guided-row]');
      if (row) {
        var key = row.getAttribute('data-line-key');
        var line = lines[key];
        if (!line) return;

        if (e.target.closest('[data-guided-remove]')) {
          delete lines[key];
          renderManifest();
          updateTotals();
          return;
        }

        if (e.target.closest('[data-guided-qty-minus]')) {
          e.preventDefault();
          setLine(line.variantId, line.qty <= 1 ? null : Object.assign({}, line, { qty: line.qty - 1 }));
          return;
        }

        if (e.target.closest('[data-guided-qty-plus]')) {
          e.preventDefault();
          setLine(line.variantId, Object.assign({}, line, { qty: line.qty + 1 }));
          return;
        }
      }

      if (e.target.closest('[data-guided-cta]')) {
        e.preventDefault();
        submitCart();
        return;
      }
    }, { passive: false });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-guided-row-variant]')) {
        var row = e.target.closest('[data-guided-row]');
        var oldKey = row.getAttribute('data-line-key');
        var line = lines[oldKey];
        if (!line) return;
        var opt = e.target.options[e.target.selectedIndex];
        var newId = opt.value;
        var newPrice = Number(opt.getAttribute('data-price'));
        var newSku = opt.getAttribute('data-sku') || '';
        delete lines[oldKey];
        lines[lineKey(newId)] = Object.assign({}, line, {
          variantId: newId,
          price: newPrice,
          sku: newSku,
          variantTitle: opt.textContent.split(' — ')[0],
        });
        renderManifest();
        updateTotals();
        return;
      }
    });

    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-guided-qty]')) {
        var row = e.target.closest('[data-guided-row]');
        var key = row.getAttribute('data-line-key');
        var line = lines[key];
        if (!line) return;
        var qty = Math.max(0, Math.floor(Number(e.target.value) || 0));
        setLine(line.variantId, qty === 0 ? null : Object.assign({}, line, { qty: qty }));
        return;
      }
      if (e.target.matches('[data-guided-catalog-search]')) {
        renderCatalog(e.target.value);
      }
    });

    function submitCart() {
      var t = calcTotals();
      if (t.totalQty === 0 || els.cta.classList.contains('is-loading')) return;

      els.cta.classList.add('is-loading');
      if (els.message) {
        els.message.className = 'bulk-guided__message';
        els.message.textContent = 'Adding to cart…';
      }

      var items = Object.keys(lines).map(function (k) {
        return {
          id: Number(lines[k].variantId),
          quantity: lines[k].qty,
          properties: {
            _bulk_order: 'yes',
            _bulk_use_case: activeUseCase ? activeUseCase.label : 'Custom',
          },
        };
      });

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw result.data;

          var attrs = {
            bulk_order: 'yes',
            bulk_use_case: activeUseCase ? activeUseCase.label : 'Custom',
            bulk_total_qty: String(t.totalQty),
            bulk_subtotal: formatMoney(t.subtotal),
          };
          if (t.eligible) attrs.bulk_discount = discountPct + '%';

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs }),
          }).then(function (res) {
            if (!res.ok) throw new Error('Cart update failed');
            return res.json();
          }).then(function () {
            var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
            if (t.eligible && applyMethod === 'code' && discountCode) {
              window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(cartUrl);
            } else {
              if (els.message && t.eligible && applyMethod === 'automatic') {
                els.message.className = 'bulk-guided__message is-success';
                els.message.textContent = discountPct + '% bulk discount applies automatically at checkout.';
              }
              window.location.href = cartUrl;
            }
          });
        })
        .catch(function (err) {
          els.cta.classList.remove('is-loading');
          if (els.message) {
            els.message.className = 'bulk-guided__message is-error';
            els.message.textContent = (err && err.description) || (err && err.message) || 'Could not add to cart. Please try again.';
          }
        });
    }
  }

  function bulkEnquirySubject(form) {
    var customerName = '';
    var orgName = '';
    var nameInput = form.querySelector('#BulkConcierge-name');
    var companyInput = form.querySelector('#BulkConcierge-company');
    if (nameInput) customerName = nameInput.value.trim();
    if (companyInput) orgName = companyInput.value.trim();
    var label = orgName || customerName || '41foods customer';
    return 'Bulk enquiry by ' + label;
  }

  function openConciergeLaneIfSuccess(root) {
    if (!root.querySelector('[data-bulk-quote-success]')) return;
    var conciergeBtn = root.querySelector('[data-guided-lane="concierge"]');
    if (conciergeBtn) conciergeBtn.click();
  }

  function initConciergeForm(root) {
    var form = root.querySelector('#BulkConciergeForm');
    if (!form || form.dataset.initialized === 'true') return;
    var submitBtn = form.querySelector('[data-concierge-submit]');
    if (!submitBtn) return;
    form.dataset.initialized = 'true';

    var subjectField = form.querySelector('[data-concierge-subject]');
    var phoneInput = form.querySelector('#BulkConcierge-phone');

    function syncSubject() {
      if (subjectField) subjectField.value = bulkEnquirySubject(form);
    }

    form.querySelectorAll('#BulkConcierge-name, #BulkConcierge-company').forEach(function (input) {
      input.addEventListener('input', syncSubject);
    });
    syncSubject();

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        phoneInput.setCustomValidity('');
      });
    }

    form.addEventListener('submit', function (e) {
      var honey = form.querySelector('[name="contact[_honey]"]');
      if (honey && honey.value) {
        e.preventDefault();
        return;
      }

      if (phoneInput) {
        var phoneDigits = (phoneInput.value || '').replace(/\D/g, '');
        if (phoneDigits.length < 10) {
          e.preventDefault();
          phoneInput.setCustomValidity('Enter a valid phone number (at least 10 digits).');
          phoneInput.reportValidity();
          return;
        }
        phoneInput.setCustomValidity('');
      }

      syncSubject();

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-bulk-guided-root]').forEach(function (root) {
      initBulkGuided(root);
      initConciergeForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bulk-guided-root]');
    if (root) {
      initBulkGuided(root);
      initConciergeForm(root);
    }
  });
})();
